import React, { useState, useEffect, useMemo, useRef } from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import { Box, Typography, Button, Tabs, Tab, Paper } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { showAlert } from "../../../../actions/alert";
import {
  getAppraisals,
  getLatestStatusbyId,
  postKraByManager,
  setMyAppraisal,
  setUpdataStatus,
} from "../../../../api/appraisal";
import { getEmployeeKraById, getKraDataList } from "../../../../api/KRAapis";
import { appraisalViewKRATable as tableDef } from "../../../../config/grid-columns-defs";
import { AgGridReact } from "ag-grid-react";
import { createCategory } from "../../../../api/asset";
import { handleAxiosError } from "../../../../config/action-config";
import CustomLargeTextCellEditor from "../../../../component/CustomLargeCellEditor";
import TabPanel from "../../../../component/TabPanel";

import SkipNextIcon from "@mui/icons-material/SkipNext";

export default function AppraisalDetail() {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%",overflowX: "scroll" }), []);
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const gridApiRef = useRef();
  const [rowData, setRowData] = useState([]);
  const [isQtyEmpty, setIsQtyEmpty] = useState(false);
  const [QtyEmpty, setQtyEmpty] = useState(false);
  const [meetingData, setMeetingData] = useState({});
  const [latestStatus, setLatestStatus] = useState([{}]);
  const { role_department } = useParams();
  const [goalData, setGoalData] = useState([]);
  const [kpiData, setKPIData] = useState([]);
  const [save, setSave] = useState(false);
  const [confirmMeeting, setConfirmMeeting] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const { id } = useParams();
  const rating = [
    { manager_rating: 1 },
    { manager_rating: 1.5 },
    { manager_rating: 2 },
    { manager_rating: 2.5 },
    { manager_rating: 3 },
    { manager_rating: 3.5 },
    { manager_rating: 4 },
    { manager_rating: 4.5 },
    { manager_rating: 5 },
  ];
  console.log("udduduud--", id);
  const [role, department] = role_department.split("_");

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  const [refreshCount, setRefreshCount] = useState(0);
  useEffect(() => {
    if (!role && !department) {
      navigate("/appraisal");
    } else {
      getTableData();
    }
  }, []);
  async function getTableData() {
    try {
      const { data } = await getEmployeeKraById(id, user.token);
      setRowData([...data.KraDetails]);
      let goal = data.KraDetails.filter((e) => e.is_kpi === false);
      let kpi = data.KraDetails.filter((e) => e.is_kpi === true);

      setGoalData(goal);
      setKPIData(kpi);
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    }
  }
  useEffect(()=>{
    getStatus();
  },[])
  console.log(id,"id")
  async function getStatus(){
    try{
   const{data} = await getLatestStatusbyId(id,user.token);
  setLatestStatus(data.data)
  
    }catch(err){
      handleAxiosError(err);
      return{error:true};
    }
  
  }

  function refreshTable(e) {
    e?.preventDefault();
    setRefreshCount((prev) => prev + 1);
  }
  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      editable: true,
    };
  }, []);
  const onCellValueChanged = async (params) => {
    const updatedRowData = [...goalData];
    const rowIndex = params.rowIndex;
    updatedRowData[rowIndex] = params.data;
    console.log(updatedRowData, "updatedRowData");
    setGoalData(updatedRowData);
  };
  const onCellValueChangedkpi = async (params) => {
    const updatedRowData = [...kpiData];
    const rowIndex = params.rowIndex;
    updatedRowData[rowIndex] = params.data;
    console.log(updatedRowData, "updatedRowData");
    setKPIData(updatedRowData);
  };
 
  const CheckData =()=>{
    if (gridApiRef?.current) {
      const editingCell = gridApiRef.current.getEditingCells()[0];
      if (editingCell) {
        gridApiRef.current.stopEditing();
      }
    }

    const EmptyCell = kpiData.some(
      (item) =>
        item.manager_remarks === "" ||
        item.manager_remarks === null ||
        item.manager_remarks === undefined ||
        item.manager_rating === "" ||
        item.manager_rating === null ||
        item.manager_rating === undefined
    );
    if (EmptyCell) {
      setQtyEmpty(EmptyCell);
      dispatch(showAlert("please fill all the fields"));
      return;
    } 
    else{
      setSave(true);
    }
  }
  const onSubmit = async (event) => {
    setSave(false);
      const exractedKeys = extractKraUpdateData([...kpiData, ...goalData]);

      try {
        const { data } = await postKraByManager(
          { KraUpdateData: exractedKeys },
          user.token
        );
        dispatch(showAlert(data.msg));
        setTimeout(()=>{
          setConfirmMeeting(true);
        },3500)
        
      } catch (error) {
        handleAxiosError(error, dispatch);
      }
    
  };
  const extractKraUpdateData = (dataList) => {
    return dataList.map((item, index) => ({
      id: item.id.toString(),
      appraisal_id: item.appraisal_id.toString(),
      manager_rating: item.manager_rating.toString(),
      manager_remarks: item.manager_remarks,
    }));
  };
  const nextfunc = () => {
    if (gridApiRef?.current) {
      const editingCell = gridApiRef.current.getEditingCells()[0];
      if (editingCell) {
        gridApiRef.current.stopEditing();
      }
    }

    const EmptyCell = goalData.some(
      (item) =>
        item.manager_remarks === "" ||
        item.manager_remarks === null ||
        item.manager_remarks === undefined ||
        item.manager_rating === "" ||
        item.manager_rating === null ||
        item.manager_rating === undefined
    );

    if (EmptyCell) {
      setIsQtyEmpty(EmptyCell);
      dispatch(showAlert("please fill all the fields"));
      return;
    } else {
      setTabIndex(1);
    }
  };
  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Appraisal Detail
          </Typography>
        </Box>
        <Box sx={{display:"flex",gap:"10px"}}>
        {  latestStatus[0].appraisal_status!=="Manager_Submitted" && tabIndex === 1 && (
           <Button
           size="medium"
           sx={{ borderRadius: "15px",fontWeight:"bold" }}
           variant="contained"
           color="info"
           onClick={() => CheckData()}
           >
             Submit
           </Button>
        )}
         <Button
           size="medium"
           sx={{ borderRadius: "15px",fontWeight:"bold" }}
           variant="contained"
           color="info"
           onClick={() => navigate("/appraisal")}
           >
             Back
           </Button>
        </Box>
      </Box>
      <br />
      <Box sx={{ borderBottom: 1, width: "100%", borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Goals"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="KPI"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          <div style={{ height: "500px" }}>
            <div style={gridStyle} className="ag-theme-alpine">
              <AgGridReact
                columnDefs={[
                  ...tableDef,
                  {
                    headerName: "Manager Remarks",
                    field: "manager_remarks",
                   minWidth:300,
                    maxWidth: 400,
                    resizable: true,
                    autoHeight: true,
                    wrapText: true,
                    cellEditor: CustomLargeTextCellEditor,
                    cellEditorPopup: true,
                    editable: true,
                    cellEditorParams: {
                      rows: 20,
                      cols: 50,
                    },
                    cellRenderer: (params) => (
                      <>
                        {!params?.data?.manager_remarks && params?.data?.manager_remarks !== 0 && isQtyEmpty ? (
                          <Box sx={{display:"flex",justifyContent:"center",gap:"3px"}} className="mandatory-cell">
                            <p style={{color:"red",fontSize:"10px",fontWeight:"bold"}}>*this Field is mandatory</p>
                          </Box>
                        ) : (
                          <Box sx={{display:"flex",gap:"3px"}}>
                            <p >{params?.data?.manager_remarks}</p>
                          </Box>
                        )}
                      </>
                      )
                  },
                  {
                    headerName: "Manager Rating",
                    field: "manager_rating",
                    minWidth: 150,
                    maxWidth: 200,
                    resizable: true,
                    autoHeight: true,
                    editable: true,
                    cellEditor: "agSelectCellEditor",
                    cellEditorParams: {
                      values: [
                        ...new Set(rating.map((man) => man.manager_rating)),
                      ],
                    },
                    cellRenderer: (params) => (
                      <>
                        {!params?.data?.manager_rating && params?.data?.manager_rating !== 0 && isQtyEmpty ? (
                          <Box sx={{display:"flex",justifyContent:"center",gap:"3px"}} className="mandatory-cell">
                            <p style={{color:"red",fontSize:"10px",fontWeight:"bold"}}>*this Field is mandatory</p>
                          </Box>
                        ) : (
                          <Box sx={{display:"flex",gap:"3px"}}>
                            <p >{params?.data?.manager_rating}</p>
                          </Box>
                        )}
                      </>
                      )
                  },
                ]}
                rowData={goalData}
                onCellValueChanged={onCellValueChanged}
                defaultColDef={defaultColDef}
              />
            </div>
          </div>
        </Paper>
        {  latestStatus[0].appraisal_status!=="Manager_Submitted" && 
        <div style={{ display: "flex", justifyContent: "end", gap: 2 }}>
          <Button
            size="large"
            sx={{ marginTop: 2, borderRadius: "15px",fontWeight:"bold" }}
            variant="contained"
            color="info"
            onClick={() => nextfunc()}
          >
            Next
            <SkipNextIcon />
          </Button>
        </div>
        } 

      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <Paper>
          <div style={{ height: "500px" }}>
            <div style={gridStyle} className={"ag-theme-alpine"}>
              <AgGridReact
                columnDefs={[
                  ...tableDef,
                  {
                    headerName: "Manager Remarks",
                    field: "manager_remarks",
                    minWidth: 300,
                    maxWidth: 400,
                    resizable: true,
                    autoHeight: true,
                    wrapText: true,
                    cellEditor: CustomLargeTextCellEditor,
                    cellEditorPopup: true,
                    editable: true,
                    cellEditorParams: {
                      rows: 20,
                      cols: 50,
                    },
                    cellRenderer: (params) => (
                      <>
                        {!params?.data?.manager_remarks && params?.data?.manager_remarks !== 0 && QtyEmpty ? (
                          <Box sx={{display:"flex",gap:"3px"}}className="mandatory-cell">
                            <p style={{color:"red",fontSize:"10px",fontWeight:"bold"}}>*this Field is mandatory</p>
                          </Box>
                        ) : (
                          <Box sx={{display:"flex",gap:"3px"}}>
                            <p style={{color:"#000"}}>{params?.data?.manager_remarks}</p>
                          </Box>
                        )}
                      </>
                    ),
                  },
                  {
                    headerName: "Manager Rating",
                    field: "manager_rating",
                    minWidth: 150,
                    maxWidth: 200,
                    resizable: true,
                    autoHeight: true,
                    editable: true,
                    cellEditor: "agSelectCellEditor",
                    cellEditorParams: {
                      values: [
                        ...new Set(rating.map((man) => man.manager_rating)),
                      ],
                    },
                    cellRenderer: (params) => (
                      <>
                        {!params?.data?.manager_rating && params?.data?.manager_rating !== 0 && QtyEmpty ? (
                          <Box sx={{display:"flex",justifyContent:"center",gap:"3px"}} className="mandatory-cell">
                            <p style={{color:"red",fontSize:"10px",fontWeight:"bold"}}>*this Field is mandatory</p>
                          </Box>
                        ) : (
                          <Box sx={{display:"flex",gap:"3px"}}>
                            <p >{params?.data?.manager_rating}</p>
                          </Box>
                        )}
                      </>
                      )
                  },
                ]}
                rowData={kpiData}
                onCellValueChanged={onCellValueChangedkpi}
                defaultColDef={defaultColDef}
              />
            </div>
          </div>
        </Paper>
      </TabPanel>
      <Dialog
  open={save}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
>
  <>
    <DialogTitle id="alert-dialog-title">Confirm Save</DialogTitle>
    <DialogContent style={{ width: "500px" }}>
      <DialogContentText id="alert-dialog-description">
        Are you sure you want to Save?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        size="medium"
        onClick={() => {
          setSave(false);
        }}
        variant="contained"
        color="inherit"
      >
        Cancel
      </Button>
      <Button
      size="medium"
        onClick={() => {
          onSubmit()
        }}
        variant="contained"
        color="info"
      >
        Confirm
      </Button>
     
    </DialogActions>
  </>
</Dialog>
<Dialog
  open={confirmMeeting}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
>
  <>
    <DialogTitle id="alert-dialog-title">Schedule a Meeting</DialogTitle>
    <DialogContent style={{ width: "500px" }}>
      <DialogContentText id="alert-dialog-description">
        Do  you want to Schedule a meeting?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        size="medium"
        onClick={() => {
          navigate("/appraisal");
        }}
        variant="contained"
        color="inherit"
      >
        No
      </Button>
      <Button
      size="medium"
        onClick={() => {
          navigate("/meeting-form/:id/")
        }}
        variant="contained"
        color="info"
      >
        Yes
      </Button>
     
    </DialogActions>
  </>
</Dialog>
    </Box>
  );
}
